import type React from "react";
import type { ReactNode } from "react";

import { Grid2 as Grid, Stack, Typography } from "@mui/material";

import { DARK_BLUE, RED } from "theme/colors";

interface Props {
  left: ReactNode;
  right: ReactNode;
  highlight?: boolean;
}

export const Row: React.FC<Props> = ({ left, right, highlight = false }) => (
  <Grid
    container
    spacing={2}
    sx={{ alignItems: "center", wrap: "nowrap", borderBottom: "1px solid", borderBottomColor: "divider", py: 2 }}
  >
    <Grid size={{ xs: 12, md: 6 }}>
      <Typography variant="subtitle1" color={DARK_BLUE[60]}>
        {left}
      </Typography>
    </Grid>
    <Grid size={{ xs: 12, md: 6 }}>
      <Typography variant="subtitle1" component="span" color={highlight ? RED[70] : "text.primary"}>
        {right}
      </Typography>
    </Grid>
  </Grid>
);

export const generateItem = (left: ReactNode, right: ReactNode) => {
  return (
    <Stack direction="row" alignItems="center" spacing={1} mb={0.5}>
      <Typography variant="subtitle1" component="span" color={DARK_BLUE[60]}>
        {left}
      </Typography>
      <Typography variant="subtitle1" component="span">
        {right}
      </Typography>
    </Stack>
  );
};
